import React, { useState, useEffect, Fragment } from 'react';
import services from '../service';
import { validateProperty, validate } from "../../Common";
import { BuyerAddEditSchemaObject } from '../BuyerSchema';
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'BUYER';

export function BuyerAddEdit(props) {

    const { data, edit } = props.location;

    const [title, setTitle] = useState("Add Buyer");
    const [buttonText, setButtonText] = useState("Save");
    const [groups, setGroups] = useState();
    const [operationEntity, setOperationEntity] = useState();
    const [buyerFiltering, setBuyerFiltering] = useState({
        groupID: '0',
        operationEntityID: '0',
        country: '',
        buyerCode: '',
        buyerName: '',
        buyerAddress: '',
        businessRegNo: '',
        billingAddress: '',
        contactPersonName: '',
        contactNumber: '',
        email: '',
        companyPhone: '',
        companyFax: '',
        isActive: true,
        creditPeriod: '0',
        creditAmount: '0'
    });

    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "completed successfuly."
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(BuyerAddEditSchemaObject).options({ allowUnknown: true });

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
        )
    }, [buyerFiltering.groupID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITBUYER');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        if (data && edit) {
            setTitle("Edit Buyer");
            let buyer = {
                buyerID: data.buyerID,
                groupID: parseInt(data.groupID),
                operationEntityID: parseInt(data.operationEntityID),
                country: data.country,
                buyerCode: data.buyerCode,
                buyerName: data.buyerName,
                buyerAddress: data.buyerAddress,
                businessRegNo: data.businessRegNo,
                billingAddress: data.billingAddress,
                contactPersonName: (data.contactPersonName == 'NULL' ? '' : data.contactPersonName),
                contactNumber: data.contactNumber,
                email: (data.email == 'NULL' ? '' : data.email),
                companyPhone: (data.companyPhone == 'NULL' ? '' : data.companyPhone),
                companyFax: (data.companyFax == 'NULL' ? '' : data.companyFax),
                isActive: data.isActive,
                creditPeriod: data.creditPeriod,
                creditAmount: data.creditAmount
            }
            setBuyerFiltering(buyer);
            setButtonText("Update");
        } else {
            setTitle("Add Buyer");
            var token = tokenService.getUserDetailsFromToken();
            setBuyerFiltering({
                ...buyerFiltering,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        }

        trackPromise(
            getGroupsForDropdown()
        );

    }


    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getOperationEntitiesForDropdown() {
        const operationEntities = await services.getAllOperationEntitiesForDropDown(buyerFiltering.groupID);
        setOperationEntity(operationEntities);
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.name === 'isActive' ? target.checked : target.value
        const error = { ...errors };
        const errorMessage = validateProperty(target, BuyerAddEditSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setBuyerFiltering({
            ...buyerFiltering,
            [e.target.name]: value
        });
        setErrors(error);
    }

    async function handleSave(e) {
        e.preventDefault();

        const errorMessages = validate(schema, buyerFiltering);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        if (!edit) {
            var result = await services.saveBuyer(buyerFiltering);
            setMessageModel({ ...messageModel, hidden: false, type: result.statusCode, disciption: result.message });
            afterSuccessfulyChanged(result.statusCode);
        }
        else if (edit) {
            var result = await services.editBuyer(buyerFiltering);
            setMessageModel({ ...messageModel, hidden: false, type: result.statusCode, disciption: result.message });
            afterSuccessfulyChanged(result.statusCode);
        }
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/buyer' })
            }, 1500);
        }
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setBuyerFiltering({
            ...buyerFiltering,
            groupID: permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            country: '',
            buyerCode: '',
            buyerName: '',
            buyerAddress: '',
            businessRegNo: '',
            billingAddress: '',
            contactPersonName: '',
            contactNumber: '',
            email: '',
            companyPhone: '',
            companyFax: '',
            isActive: true,
            creditPeriod: '0',
            creditAmount: '0'
        });
        setErrors('');
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />

            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">

                                <PageHeader
                                    title={title}
                                    isButtonEnable={true}
                                    path="/buyer"
                                    buttonText="Back to listing"
                                />

                            </div>
                            <hr />

                            <form onSubmit={(e) => handleSave(e)} disabled={false}>

                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            value={buyerFiltering.groupID}
                                            onChange={(e) => handleChange(e)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)
                                            }
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        }
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            value={buyerFiltering.operationEntityID}
                                            onChange={(e) => handleChange(e)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)
                                            }
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>
                                        }
                                    </div>
                                    <div className="col-md pb-1">

                                        <TextField
                                            fullWidth
                                            label="Business RegNo *"
                                            name="businessRegNo"
                                            id="businessRegNo"
                                            value={buyerFiltering.businessRegNo}
                                            type="text"
                                            onChange={(e) => handleChange(e)}
                                        />
                                        {errors["businessRegNo"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["businessRegNo"]}</FormHelperText>
                                        }
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <div className="col-md pb-1">

                                        <TextField
                                            fullWidth
                                            label="Buyer Code *"
                                            name="buyerCode"
                                            id="buyerCode"
                                            value={buyerFiltering.buyerCode}
                                            type="text"
                                            onChange={(e) => handleChange(e)}
                                        />
                                        {errors["buyerCode"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["buyerCode"]}</FormHelperText>
                                        }
                                    </div>

                                    <div className="col-md pb-1">

                                        <TextField
                                            fullWidth
                                            label="Buyer Name *"
                                            name="buyerName"
                                            id="buyerName"
                                            value={buyerFiltering.buyerName}
                                            type="text"
                                            onChange={(e) => handleChange(e)}
                                        />
                                        {errors["buyerName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["buyerName"]}</FormHelperText>
                                        }
                                    </div>

                                    <div className="col-md pb-1">

                                        <TextField
                                            fullWidth
                                            label="Buyer Address *"
                                            name="buyerAddress"
                                            id="buyerAddress"
                                            value={buyerFiltering.buyerAddress}
                                            type="text"
                                            onChange={(e) => handleChange(e)}
                                        />
                                        {errors["buyerAddress"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["buyerAddress"]}</FormHelperText>
                                        }
                                    </div>

                                </div>
                                <div className="form-group row">

                                    <div className="col-md pb-1">

                                        <TextField
                                            fullWidth
                                            label="Country *"
                                            name="country"
                                            id="country"
                                            value={buyerFiltering.country}
                                            type="text"
                                            onChange={(e) => handleChange(e)}
                                        />
                                        {errors["country"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["country"]}</FormHelperText>
                                        }
                                    </div>
                                    <div className="col-md pb-1">

                                        <TextField
                                            fullWidth
                                            label="Billing Address *"
                                            name="billingAddress"
                                            id="billingAddress"
                                            value={buyerFiltering.billingAddress}
                                            type="text"
                                            onChange={(e) => handleChange(e)}
                                        />
                                        {errors["billingAddress"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["billingAddress"]}</FormHelperText>
                                        }
                                    </div>
                                    <div className="col-md pb-1">

                                        <TextField
                                            fullWidth
                                            label="Contact Person Name "
                                            name="contactPersonName"
                                            id="contactPersonName"
                                            value={buyerFiltering.contactPersonName}
                                            type="text"
                                            onChange={(e) => handleChange(e)}
                                        />
                                        {errors["contactPersonName"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["contactPersonName"]}</FormHelperText>
                                        }
                                    </div>

                                </div>
                                <div className="form-group row">
                                    <div className="col-md pb-1">

                                        <TextField
                                            fullWidth
                                            label="Contact Number"
                                            name="contactNumber"
                                            id="contactNumber"
                                            value={buyerFiltering.contactNumber}
                                            type="text"
                                            onChange={(e) => handleChange(e)}
                                        />
                                        {errors["contactNumber"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["contactNumber"]}</FormHelperText>
                                        }
                                    </div>

                                    <div className="col-md pb-1">

                                        <TextField
                                            fullWidth
                                            label="Email "
                                            name="email"
                                            id="email"
                                            value={buyerFiltering.email}
                                            type="text"
                                            onChange={(e) => handleChange(e)}
                                        />
                                        {errors["email"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["email"]}</FormHelperText>
                                        }
                                    </div>

                                    <div className="col-md pb-1">

                                        <TextField
                                            fullWidth
                                            label="Company Phone "
                                            name="companyPhone"
                                            id="companyPhone"
                                            value={buyerFiltering.companyPhone}
                                            type="text"
                                            onChange={(e) => handleChange(e)}
                                        />
                                        {errors["companyPhone"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["companyPhone"]}</FormHelperText>
                                        }
                                    </div>

                                    <div className="col-md pb-1">

                                        <TextField
                                            fullWidth
                                            label="Company Fax "
                                            name="companyFax"
                                            id="companyFax"
                                            value={buyerFiltering.companyFax}
                                            type="text"
                                            onChange={(e) => handleChange(e)}
                                        />
                                        {errors["companyFax"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["companyFax"]}</FormHelperText>
                                        }
                                    </div>
                                </div>
                                <div className="card-title pt-3"><p style={{ fontSize: "16px" }}>Credit Details</p></div>
                                <div className="form-group row">
                                    <div className="col">
                                        <TextField fullWidth label="Credit Period (Days)*"
                                            name="creditPeriod"
                                            id="creditPeriod"
                                            value={buyerFiltering.creditPeriod}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["creditPeriod"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["creditPeriod"]}</FormHelperText>}
                                    </div>
                                    <div className="col">
                                        <TextField fullWidth label="Credit Amount *"
                                            name="creditAmount"
                                            id="creditAmount"
                                            value={buyerFiltering.creditAmount}
                                            type="text"
                                            onChange={(e) => handleChange(e)}
                                        />
                                        {errors["creditAmount"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["creditAmount"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div>
                                    <label>Active</label>
                                    <div className="form-group row">
                                        <div className="col-md ">
                                            <input
                                                id="isActive"
                                                switch="none"
                                                className="mr-2"
                                                type="checkbox"
                                                name="isActive"
                                                onChange={(e) => handleChange(e)}
                                                checked={buyerFiltering.isActive}
                                            />
                                            <label htmlFor="isActive" data-on-label="Yes"
                                                data-off-label="No"></label>
                                        </div>
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        type="submit"
                                        className="btn btn-primary"
                                        value={buttonText}
                                        disabled={validate(schema, buyerFiltering)}
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>

                            </form>

                        </div>
                    </div>
                </div>
            </div>

            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />

        </Fragment>
    );
}